import "./Academy.module.css";
import MainSiteHeader from "@/reusable_sections/Header";
import MasterYourMarketing from "./sections/MasterYourMarketing";
import IndustryInsights from "./sections/IndustryInsights";
import MarketplaceSupport from "./sections/MarketplaceSupport";
import Footer from "@/reusable_sections/Footer";
export default function AcademyPage() {
  return <div>
      <MainSiteHeader />
      <MasterYourMarketing />
      <IndustryInsights />
      <MarketplaceSupport />
      <Footer />
    </div>;
}